@if (vm$ | async; as vm) {
@if (vm.hubState.loading) {
<div class="loading-parent" [attr.data-theme]="vm.theme">
    <app-spinner></app-spinner>
</div>
} @else if (vm.hubState.error === null || vm.hubState.error === '' ){
<div [attr.data-theme]="vm.theme">
    <app-sidebar></app-sidebar>
    <div class="hub-container">
        <router-outlet></router-outlet>
    </div>
</div>
} @else {
<div class="error-container" [attr.data-theme]="vm.theme">
    <div class="company-logo">
        <app-svg-icon class="nessy-logo"></app-svg-icon>
    </div>
    <h2>Oops! looks like theres an error</h2>
    @if (vm.hubState.error !== null) {
    <h3>error message: {{vm.hubState.error}}</h3>
    }
    <button class="btn btn-primary" (click)="logout()">Logout</button>
</div>
}
}